import moment from "moment";
export const trimAddress = (addr) => {
  return `${addr.substring(0, 6)}...${addr.substring(addr.length - 4)}`;
}


export const contract = {
  56: {
    STAKE_ADDRESS: "0xa0e361f863d3b576fa10661134532b150e2cd160",
    MULTICALL_ADDRESS: "0x2cC8FE3e04d7B1EDAeB42E2e73f78c4cAc074116"
  },
  97: {
    STAKE_ADDRESS: "0x938c1aa5270c528e951cac03829b7c0ebbb150a2",
    MULTICALL_ADDRESS: "0xa54fE4a3DbD1Eb21524Cd73754666b7E13b4cB18"
  }
}

export const DEFAULT_CHAIN = 56;
export const DEFAULT_RPC = "https://bsc-dataseed1.binance.org/"
// export const DEFAULT_RPC = "https://data-seed-prebsc-2-s2.bnbchain.org:8545"
export const PROJECT_ID = "27b9720018bf7f8740936e6a6eb28604";
export const DECIMALS = 18;
export const SYMBOL = "CBN"
export const EXPLOER = 'https://bscscan.com/';

export const formatDateWithZone = (unixTime) => {
  try {
    let dateString = new Date(unixTime).toString();

    let startIndex = dateString.indexOf("(");
    let modifyDate = dateString.substring(0, startIndex);
    return modifyDate;
  }
  catch (err) {
    console.log(err.message);
  }

}

export const formatDate = (unixTime, onlydate = false) => {
  try {
    if (onlydate) {
      let dateString = moment(unixTime).format("LL"); 
      return dateString;
    }
    else {
      let dateString = moment(unixTime).format('lll');
      return dateString;
    }
  }
  catch (err) {
    console.log(err.message);
  }

}


export const getDaysLeft = (unixTimestamp) =>{
  // Get current time in milliseconds
  var currentTime = Date.now();

  // Convert UNIX timestamp to milliseconds
  var targetTime = unixTimestamp * 1000;

  // Calculate the difference in milliseconds
  var difference = targetTime - currentTime;

  // Convert milliseconds to days
  var daysLeft = Math.ceil(difference / (1000 * 60 * 60 * 24));

  return daysLeft;
}